import React from "react";
import "./Footer.css";
import logolg from "../images/logolg.png";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="footer-icon">
          <p>
            <a href="/">
              <img className="logo" src={logolg} alt="" />
            </a>
            <small>
              {" "}
              &copy; {new Date().getFullYear()} JackThePilot - All Rights
              Reserved.
            </small>
            <ul>
              <a
                href="https://www.tiktok.com/@jackthepilot?_t=ZS-8y3gACKFQKC&_r=1" className="tiktok-social"
              >
                <i className="icons fa-brands fa-tiktok"></i>
              </a>

              <a
                href="https://www.facebook.com/share/1SAYbL1kyU/?mibextid=wwXIfr" className="facebook-social"
              >
                <i className="icons fa-brands fa-facebook"></i>
              </a>

              <a
                href="https://www.instagram.com/jackthepilott?igsh=MXBpZHdlNGtwNnhhZA%3D%3D&utm_source=qr" className="instagram-social"
              >
                <i className="icons fa-brands fa-instagram"></i>
              </a>

              <a
                href="https://wa.me/76878378?text=Hello%20there%20!%20I%20would%20like%20some%20details%20about%20the%20cross%20country%20flight." className="whatsapp-social"
              >
                <i className="icons fa-brands fa-whatsapp"></i>
              </a>

              
                <a
                  href="https://youtube.com/@jackthepilot?si=Ve9NIO4JqFX082zP" className="youtube-social"
                >
                  <i className="icons fa-brands fa-youtube"></i>
                </a>
            </ul>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
